// extracted by mini-css-extract-plugin
export default {"container":"success-modal_container__PEm7P","image":"success-modal_image__mQFdi","title":"success-modal_title__ytDmB","content":"success-modal_content__BIuK5"};